import { connect } from 'react-redux';
import { getCurrentCycle, getCurrentBypassedPlan } from 'reducers';
import { fetch as fetchCycles } from 'billing/cycles/actions';
import DataRemaining from './DataRemaining';

const mapStateToProps = (state, { subId }) => ({
  currentCycle: getCurrentCycle(state),
  currentPlan: getCurrentBypassedPlan(state, subId),
});

const mapDispatchToProps = {
  fetchCycles,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataRemaining);
